// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"94":"ce3a9d0f54ee6b0faac4","236":"408a4069dc03b8b3a0d5","775":"1eb4ef402244608a515e"}[chunkId] + ".js";
};